import React from 'react';
import Table from '../../../Payments/Table';
import { TableCell, TableRow } from '@material-ui/core';
import { useCommonStyles as useTableStyles } from '../../../Payments/Table/CommonStyles';
import { BookingsInsightsReport } from 'model/BookingsReport';
import styles from './InsightsDetailTable.module.css';

interface InsightsDetailTableProps {
    loading: boolean;
    insights: BookingsInsightsReport | null;
}

export const InsightsDetailTable: React.FunctionComponent<InsightsDetailTableProps> = props => {
    const tableStyles = useTableStyles();

    const headersTable = (
        <>
            <TableCell className={tableStyles.headerCell}>Total Upcoming (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Completed (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>Total Cancelled (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>No Show (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>Online Booking (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>Business-Booked (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>New Clients (%)</TableCell>
            <TableCell className={tableStyles.headerCell}>Returning Clients (%)</TableCell>
        </>
    );

    const rowsInsightsDetail = (
        <>
            {props.insights && (
                <>
                    <TableRow>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalUpcoming} (${props.insights.percentUpcoming}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalCompleted} (${props.insights.percentCompleted}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalCancelled} (${props.insights.percentCancelled}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalNoShow} (${props.insights.percentNoShow}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalOnlineBooking} (${props.insights.percentOnlineBooking}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalBusinessBooked} (${props.insights.percentBusinessBooked}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalNewClients} (${props.insights.percentNewClients}%)`}</TableCell>
                        <TableCell
                            className={tableStyles.cell}
                        >{`${props.insights.totalReturningClients} (${props.insights.percentReturningClients}%)`}</TableCell>
                    </TableRow>
                </>
            )}
        </>
    );

    return (
        <div className={styles.root}>
            <Table
                headers={headersTable}
                rows={props.insights ? rowsInsightsDetail : <></>}
                loading={props.loading}
                withoutColor={true}
            />
        </div>
    );
};

export default InsightsDetailTable;
